import { container } from '@/core/di';
import { EventTrackerFacade } from './EventTrackerFacade';

export { EventConsoleLoggerFacade } from './EventConsoleLoggerFacade';
export { EventTrackerFacade };

export const eventTracker = (): EventTrackerFacade => container.resolve(EventTrackerFacade);
